import { Component, h, Prop } from '@stencil/core';
import classnames from 'classnames';

// TODO: Does this even work? - Set this to be global
const assetRoot = process.env.NODE_ENV === 'production' ? 'https://www.kbb.com/my-wallet/assets' : 'https://staging.kbb.com/my-wallet/assets';

const FONT_FACE = `
    @font-face {
        font-family: AXLcons;
        src: url('${assetRoot}/fonts/AXLcons.eot');
        src: url('${assetRoot}/fonts/AXLcons.eot#iefix') format("embedded-opentype"),
        url('${assetRoot}/fonts/AXLcons.woff2') format("woff2"),
        url('${assetRoot}/fonts/AXLcons.woff') format("woff"),
        url('${assetRoot}/fonts/AXLcons.ttf') format("truetype"),
        url('${assetRoot}/fonts/AXLcons.svg#AXLcons') format("svg")
    }
`;

@Component({
    tag: 'axl-glyphicon',
    styleUrl: 'glyphicon.scss',
})

// TODO: Can this be a functional component?
export class Glyphicon {

    @Prop() glyph: string;
    @Prop() glyphClass: string;

    componentWillLoad() {
        const id = 'axl-glyph-icon-font-face';
        if (!document.getElementById(id)) {
            const iconStyleElmt = document.createElement('style');
            iconStyleElmt.id = id;
            iconStyleElmt.appendChild(document.createTextNode(FONT_FACE));
            document.head.appendChild(iconStyleElmt);
        }
    }

    render() {
        return (
            <span class={classnames(`glyphicon glyphicon-${this.glyph}`, this.glyphClass)} />
        )
    }
};
